import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getItemsAndPackagesSkus = get(
  'inventory.components.reports.itemsAndPackagesSkus'
);

export const getItemsAndPackagesSkusSearchQuery = createSelector(
  getItemsAndPackagesSkus,
  get('searchQuery')
);
